import React, { useCallback } from 'react'

import { Button as ReferaButton } from '@refera/ui-web'
import HeaderTitle from '_/components/header-title'
import useStyles from './styles'
import { navigate, useParams } from '@reach/router'
import { Grid } from '@material-ui/core'

import Button from '_components/button'
import { getHistoryLogs } from '_modules/history-logs/actions'
import { useDialog } from '_/hooks/use-dialog'
import TriageForm from './components/TriageForm'
import { useDispatch } from 'react-redux'
import { ROUTES } from '_/utils/constants'
import { TriageFormProvider, useTriageForm } from './components/TriageForm/use-triage-form'
import { useFormContext } from 'react-hook-form'

const Header = ({ serviceOrderId }) => {
  const styles = useStyles()
  const { showDialog, closeDialog } = useDialog()
  const dispatch = useDispatch()

  const { isLoading } = useTriageForm()
  const methods = useFormContext()

  const {
    formState: { dirtyFields },
  } = methods

  const handleBackNavigation = useCallback(() => {
    dispatch(getHistoryLogs(serviceOrderId))
    return navigate(`${ROUTES.SERVICE_ORDER}/${serviceOrderId}`)
  }, [navigate, serviceOrderId])

  const handleCancel = () => {
    if (Object.keys(dirtyFields).length > 0) {
      showDialog({
        type: 'warning',
        subject: 'Você tem certeza que deseja cancelar estas alterações?',
        labelApprove: 'Sim',
        labelCancel: 'Não',
        onApprove: () => {
          closeDialog()
          handleBackNavigation()
        },
        onCancel: closeDialog,
      })
    } else {
      handleBackNavigation()
    }
  }

  return (
    <HeaderTitle title="Triagem" backButtonAction={handleBackNavigation}>
      <Grid className={styles.headerButtons}>
        <Button
          className={styles.button}
          type="submit"
          form="triageForm"
          color="primary"
          variant="contained"
          disabled={isLoading}
        >
          Salvar
        </Button>
        <ReferaButton variant="secondary" color="red" onClick={handleCancel}>
          Cancelar
        </ReferaButton>
      </Grid>
    </HeaderTitle>
  )
}

const TriageView = () => {
  const { serviceOrderId } = useParams()
  const styles = useStyles()

  return (
    <TriageFormProvider>
      <Header serviceOrderId={serviceOrderId} />
      <div className={styles.triageContainer}>
        <TriageForm serviceOrderId={serviceOrderId} />
      </div>
    </TriageFormProvider>
  )
}

export default TriageView
